<template>
  <div>
    <vx-card title="General Informations" class="mb-base">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow"></div>
        <router-link :to="linkEditGeneral">
          <feather-icon icon="EditIcon"
        /></router-link>
      </div>
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Commercial Registration Type
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          {{ data.commercialTypeName }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Commercial Registration Prefix
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          {{ data.commercialPrefixName }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Company Name EN
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full">
          {{ data.companyNameEn }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Company Name TH
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full">
          {{ data.companyNameTh }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Tax ID
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">{{ data.taxId }}</div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Branch ID
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">{{ data.branchId }}</div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Number of Employees
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full ">
          {{ number(data.numberofEmployees) }}
        </div>
      </div>

      <!-- <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Address
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full ">
          {{ data.companyAddress }}
        </div>
      </div> -->

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          House Number (เลขที่)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapHouseNum1 }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Moo (หมู่)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">{{ data.sapStreet }}</div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Alley (ซอย)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapStrSuppl1 }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Street (ถนน)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapStrSuppl3 }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          District (อำเภอ / เขต)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapCity2 }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Sub-district (ตำบล / แขวง)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapStrSuppl2 }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Postal Code (รหัสไปรษณีย์)
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.sapPostCode1 }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Country
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          {{ data.countryName }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Province
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          {{ data.provinceName }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Company Establish
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ format(data.companyEstablishDate) }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Company Turnover
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          {{ number(data.companyTurnOver) }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Company Website
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyWebSite }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Telephone
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyTelephone }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Registered Capital
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ number(data.registeredCapital) }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Experience Year
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.experienceYear }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Experienced in Business
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.experienceIn }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Certificates
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">{{ data.isoname }}</div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          License/Permission
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.licenseName }}
        </div>
      </div>
    </vx-card>
    <vx-card title="Contact Informations" class="mb-base">
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Contact Name
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyContactPoint }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Telephone Number
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyTelephone }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Email
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyToEmail }}
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          CC Email
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full ">
          {{ data.companyCcEmail }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Contact Point in Gulf
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full ">
          {{ data.gulfContactPointName }}
        </div>
      </div>

      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full font-semibold label-text">
          Others
        </div>
        <div class="vx-col md:w-3/4 sm:w-1/1 w-full ">
          {{ data.others }}
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Services
import { _vendorservice } from "../../services/vendorservices";
import { dateFormat, numberFormat } from "../../services/utility";

export default {
  props: {
    propVendorID: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.getGeneralInfo();
  },
  methods: {
    async getGeneralInfo() {
      this.data = await _vendorservice.GetVendorInfoById(this.propVendorID);
      // console.log(this.data);
    },

    format(date) {
      if (date != null) return dateFormat(date);

      return null;
    },

    number(number) {
      if (number != null) return numberFormat(number);
    },
  },
  computed: {
    linkEditGeneral() {
      return (
        "/procurement-management/vendor/main/edit/generalinfo/" +
        this.$route.params.id
      );
    },
  },
};
</script>

<style lang="scss">
table {
  td {
    vertical-align: top;
    min-width: 300px;
    padding-bottom: 0.8rem;
    word-break: break-all;
  }

  &:not(.permissions-table) {
    td {
      @media screen and (max-width: 370px) {
        display: block;
      }
    }
  }
}
</style>
